/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wait_Until_Processing_CompleteInputs */

const en_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait until all files are finished processing before closing this window.`)
};

const fr_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez attendre que tous les fichiers soient traités avant de fermer cette fenêtre.`)
};

const de_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte warten Sie, bis alle Dateien vollständig verarbeitet sind, bevor Sie dieses Fenster schließen.`)
};

const it_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attendi che l'elaborazione di tutti i file sia terminata prima di chiudere questa finestra.`)
};

const ru_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, подождите, пока обработка всех файлов завершится, прежде чем закрывать это окно.`)
};

const es_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espere hasta que todos los archivos terminen de procesarse antes de cerrar esta ventana.`)
};

const zh_cn2_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请等待所有文件处理完毕后再关闭此窗口。`)
};

const ja_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このウィンドウを閉じる前に、すべてのファイルの処理が完了するまでお待ちください。`)
};

const hi_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया इस विंडो को बंद करने से पहले सभी फाइलों की प्रोसेसिंग पूरी होने तक प्रतीक्षा करें।`)
};

const pt_pt2_wait_until_processing_complete = /** @type {(inputs: Wait_Until_Processing_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguarde até que todos os arquivos sejam processados completamente antes de fechar esta janela.`)
};

/**
* | output |
* | --- |
* | "Please wait until all files are finished processing before closing this window." |
*
* @param {Wait_Until_Processing_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const wait_until_processing_complete = /** @type {((inputs?: Wait_Until_Processing_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wait_Until_Processing_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_wait_until_processing_complete(inputs)
	if (locale === "de") return de_wait_until_processing_complete(inputs)
	if (locale === "it") return it_wait_until_processing_complete(inputs)
	if (locale === "ru") return ru_wait_until_processing_complete(inputs)
	if (locale === "es") return es_wait_until_processing_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_wait_until_processing_complete(inputs)
	if (locale === "ja") return ja_wait_until_processing_complete(inputs)
	if (locale === "hi") return hi_wait_until_processing_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_wait_until_processing_complete(inputs)
	return en_wait_until_processing_complete(inputs)
});